<h2 mat-dialog-title>Rename {{ data.what }}</h2>
<div mat-dialog-content>
  <p class="text-muted">
    Saved layouts remember selections by this text. Applying rewrites every saved layout that uses the current value, in the same save,
    so none of them quietly loses it.
  </p>
  <p>Current: <code>{{ data.current }}</code></p>
  <mat-form-field class="full-width">
    <mat-label>New {{ data.what }}</mat-label>
    <input matInput [(ngModel)]="newValue" name="newValue" autocomplete="off" [disabled]="busy" />
  </mat-form-field>

  <div *ngIf="error" style="color: #b00020; margin-bottom: 8px">{{ error }}</div>

  <div *ngIf="previewIsCurrent" style="border: 1px solid #ccc; border-radius: 4px; padding: 8px 12px">
    <div *ngIf="preview.affectedLayoutCount === 0">No saved layouts use the current value, so only the definition changes.</div>
    <div *ngIf="preview.affectedLayoutCount > 0">
      <b>{{ preview.affectedLayoutCount }}</b> saved layout(s) use it<span *ngIf="preview.affectedRecurringCount > 0">, including
      <b>{{ preview.affectedRecurringCount }}</b> recurring export(s)</span>.
      <span *ngIf="!preview.headerChangeOnly">They will be rewritten to the new value.</span>
      <span *ngIf="preview.headerChangeOnly">Layouts are not rewritten, but the column header in every export that includes it changes - anything downstream that reads that header will see the new name.</span>
    </div>
  </div>
</div>
<div mat-dialog-actions>
  <button mat-raised-button class="piButton" (click)="onPreview()" [disabled]="busy || !newValue.trim() || newValue.trim() === data.current">Preview impact</button>&nbsp;
  <button mat-raised-button class="piButton" (click)="onApply()" [disabled]="busy || !previewIsCurrent">Apply rename</button>&nbsp;
  <button mat-raised-button class="piButton" (click)="onCancelClick()">Cancel</button>
  <span *ngIf="busy" style="margin-left: 8px"><i class="fas fa-spinner fa-pulse"></i></span>
</div>
